import { useState, useEffect, useCallback } from 'react';
import { useCheckoutApi } from '../../../../../../../../../../react-common/api/useCheckoutApi';
import { useAppContext } from '@app/react-common/AppContext';
import { CheckoutGroupSettings } from '../../../models/CheckoutGroupSettings';

const useCheckoutGroupSettings = (shippingMethodGroupId: number) => {
  const [checkoutGroupSettings, setCheckoutGroupSettings] = useState<CheckoutGroupSettings>();
  const { showToast, showFullPageLoader } = useAppContext();

  const failureHandler = useCallback(async () => {
    showToast({ message: `An error has ocurred. Please contact support if the problem persists.`, mode: 'danger' });
  }, []);

  const checkoutApi = useCheckoutApi(failureHandler);

  const fetchData = async () => {
    const response = await checkoutApi.get(`/admin/v1/shipping-methods-group-settings/${shippingMethodGroupId}`);
    setCheckoutGroupSettings(response.data as CheckoutGroupSettings);
  };
  useEffect(() => {
    showFullPageLoader(true);
    fetchData().finally(() => {
      showFullPageLoader(false);
    });
  }, [shippingMethodGroupId]);
  return {
    checkoutGroupSettings,
    setCheckoutGroupSettings,
  };
};

export default useCheckoutGroupSettings;
